import { render, staticRenderFns } from "./AddClientToTalentModal.vue?vue&type=template&id=29778446"
import script from "./AddClientToTalentModal.vue?vue&type=script&lang=js"
export * from "./AddClientToTalentModal.vue?vue&type=script&lang=js"
import style0 from "./AddClientToTalentModal.vue?vue&type=style&index=0&id=29778446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports